import { Theme } from '@mui/material';

import createStyles from '@mui/styles/createStyles';
import makeStyles from '@mui/styles/makeStyles';

export const useExperimentCardStyles = makeStyles((theme: Theme) =>
  createStyles({
    card: {
      marginTop: theme.spacing(1.5),
      padding: theme.spacing(3),
    },
    heading: {
      fontWeight: 'bold',
    },
    secondaryBtn: {
      borderColor: theme.palette.error.main,
      color: theme.palette.error.main,
      fontWeight: 'bold',
    },
    running: {
      backgroundColor: theme.palette.success.main,
      color: theme.palette.success.contrastText,
    },
  }),
);
